<template>
  <div class="col">
    <form
      @submit.prevent="sendForm"
      class="mt-3"
      v-if="canAdd"
    >
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-12 mb-2">
              <h4><span v-if="formType == 'create'">Add</span><span v-else>Edit</span> Campaign</h4>
            </div>
            <div class="col-lg col-md-6 col-sm-12 form-group">
              <label class="label label-default required">Name</label>
              <input
                type="text"
                required
                class="form-control"
                v-model.trim="formData.Name"
              >
              <small class="text-muted">Min. 5 characters, Only letters, numbers, dots, hyphens & underscores</small>
            </div>
            <div class="col-lg col-md-6 col-sm-12 form-group">
              <label class="label label-default required">Template</label>
              <select
                v-model="formData.Template"
                placeholder="Please Select"
                required
                class="custom-select form-control"
              >
                <option
                  class="placeholder"
                  disabled
                  value=""
                  selected=""
                >
                  Please Select
                </option>
                <option
                  v-for="template in listTemplatesCreated"
                  :value="template.name"
                  :key="template.id"
                >
                  {{ template.name }} ({{ template.type }})
                </option>
              </select>
            </div>
            <div class="col-lg col-md-12 col-sm-12 form-group">
              <div class="row">
                <label class="pl-0 col-12 label label-default required">Date / Time</label>
                <input
                  type="date"
                  required
                  :min="now"
                  class="form-control col-lg-5 col-md-6"
                  v-model="formData.date"
                >
                <input
                  type="time"
                  pattern="HH:mm"
                  required
                  class="form-control col-lg-5  col-md-4 offset-1"
                  v-model="formData.time"
                >
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-lg-12 col-md-12 col-sm-12 form-group">
              <label class="pl-0 col-12 label label-default">
                Send ONLY to these languages <small>(none selected = Send to ALL):</small>
              </label>
              <ul
                class="in-cboxtags"
              >
                <li>
                  <input
                    type="checkbox"
                    v-model="formData.IncludedLanguages"
                    name="includedLanguages"
                    id="checkboxNorwegian"
                    value="no"
                  >
                  <label for="checkboxNorwegian">Norwegian</label>
                </li>
                <li>
                  <input
                    type="checkbox"
                    v-model="formData.IncludedLanguages"
                    name="includedLanguages"
                    id="checkboxEnglish"
                    value="en"
                  >
                  <label for="checkboxEnglish">English</label>
                </li>
                <li>
                  <input
                    type="checkbox"
                    v-model="formData.IncludedLanguages"
                    name="includedLanguages"
                    id="checkboxSpanish"
                    value="es"
                  >
                  <label for="checkboxSpanish">Spanish</label>
                </li>
                <li>
                  <input
                    type="checkbox"
                    v-model="formData.IncludedLanguages"
                    name="includedLanguages"
                    id="checkboxDeutsch"
                    value="de"
                  >
                  <label for="checkboxDeutsch">Deutsch</label>
                </li>
                <li>
                  <input
                    type="checkbox"
                    v-model="formData.IncludedLanguages"
                    name="includedLanguages"
                    id="checkboxItalian"
                    value="it"
                  >
                  <label for="checkboxItalian">Italian</label>
                </li>
                <li>
                  <input
                    type="checkbox"
                    v-model="formData.IncludedLanguages"
                    name="includedLanguages"
                    id="checkboxFrench"
                    value="fr"
                  >
                  <label for="checkboxFrench">French</label>
                </li>
                <li>
                  <input
                    type="checkbox"
                    v-model="formData.IncludedLanguages"
                    name="includedLanguages"
                    id="checkboxPolish"
                    value="pl"
                  >
                  <label for="checkboxPolish">Polish</label>
                </li>
                <li>
                  <input
                    type="checkbox"
                    v-model="formData.IncludedLanguages"
                    name="includedLanguages"
                    id="checkboxDutch"
                    value="nl"
                  >
                  <label for="checkboxDutch">Dutch</label>
                </li>
                <li>
                  <input
                    type="checkbox"
                    v-model="formData.IncludedLanguages"
                    name="includedLanguages"
                    id="checkboxSwedish"
                    value="sv"
                  >
                  <label for="checkboxSwedish">Swedish</label>
                </li>
                <li>
                  <input
                    type="checkbox"
                    v-model="formData.IncludedLanguages"
                    name="includedLanguages"
                    id="checkboxDanish"
                    value="da"
                  >
                  <label for="checkboxDanish">Danish</label>
                </li>
                <li class="ks-selected">
                  <input
                    type="checkbox"
                    v-model="formData.IncludedLanguages"
                    name="includedLanguages"
                    id="checkboxFinnish"
                    value="fi"
                  >
                  <label for="checkboxFinnish">Finnish</label>
                </li>
                <li>
                  <input
                    type="checkbox"
                    v-model="formData.IncludedLanguages"
                    name="includedLanguages"
                    id="checkboxPortuguese"
                    value="pt"
                  >
                  <label for="checkboxPortuguese">Portuguese</label>
                </li>
                <li>
                  <input
                    type="checkbox"
                    v-model="formData.IncludedLanguages"
                    name="includedLanguages"
                    id="checkboxRussian"
                    value="ru"
                  >
                  <label for="checkboxRussian">Russian</label>
                </li>
              </ul>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 form-group">
              <label class="pl-0 col-12 label label-default d-block">
                Send ONLY to subsribers with following provinces as a preferance
                <small>(none selected = Send to ALL)</small>
              </label>
              <p>
                <button
                  class="btn btn-sm btn-info"
                  @click.prevent="selectAllProvinces()"
                >
                  Select All
                </button>

                <button
                  class="btn btn-sm btn-info"
                  @click.prevent="resetProvinces()"
                >
                  Reset Selection
                </button>
              </p>
              <ul class="in-cboxtags">
                <li
                  v-for="province in provinces"
                  :key="province.Id"
                >
                  <input
                    type="checkbox"
                    v-model="formData.IncludedProvinces"
                    name="includedProvinces"
                    :id="'checkboxProvince' + province.Id"
                    :value="province.Id"
                    @change="onProvinceSelect"
                  >
                  <label :for="'checkboxProvince' + province.Id">{{ province.Name }}</label>
                </li>
              </ul>
              <label class="pl-0 col-12 label label-default d-block">
                Or by Provinces grouped by Region <small>(none selected = Send to ALL provinces)</small>
              </label>
              <ul class="in-cboxtags">
                <li
                  v-for="region in regions"
                  :key="region.Id"
                >
                  <input
                    type="checkbox"
                    v-model="formData.IncludedRegions"
                    name="includedRegions"
                    :id="'checkboxRegion' + region.Id"
                    :value="region.Id"
                    @change="onRegionSelect"
                  >
                  <label :for="'checkboxRegion' + region.Id">{{ region.Name }}</label>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <button
            type="submit"
            class="btn btn-success d-lg-inline d-md-inline d-inline-block float-xl-right float-lg-right float-md-right float-sm-right"
          >
            <i class="jam jam-save" /> Save
          </button>
        </div>
      </div>
    </form>

    <div class="row mt-3">
      <div class="col-lg-12">
        <form
          @submit="searchCampaigns"
          v-if="!canAdd"
        >
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-12 mb-2">
                  <h4>Search Campaigns</h4>
                </div>
                <div class="col-xl col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="templateName"
                  >
                    Prefix
                  </label>
                  <input
                    v-model="formSearch.prefix"
                    type="text"
                    class="form-control"
                    id="templateName"
                    name="templateName"
                    placeholder="PREFIX: %text% NOT ALLOWED"
                  >
                  <span class="caption-helper text-muted"><small>(No '%text%' format allowed - this will search 'text%')</small></span>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button
                type="submit"
                class="btn btn-primary float-right"
              >
                <i class="jam jam-search" /> Search
              </button>
            </div>
          </div>
        </form>

        <div class="row mt-3">
          <div class="col-12">
            <div class="table mt-4">
              <table
                id="campaignsCampaigns"
                class="w-100 pb-4 pt-4 responsive white-space table-striped"
              >
                <thead>
                  <tr>
                    <th>
                      Name
                    </th>
                    <th>
                      Input
                    </th>
                    <th>
                      Campaign Time
                    </th>
                    <th class="text-right">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="campaign in listCampaignsCreated"
                    :key="campaign.Id"
                  >
                    <td>{{ campaign.Name }}</td>
                    <td>{{ campaign.Input }}</td>
                    <td>{{ $moment(campaign.Time).format('DD/M/YYYY HH:mm') }}</td>
                    <td class="text-right">
                      <button
                        class="btn btn-danger btn-sm"
                        @click="deleteCampaign(campaign.Name)"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tfoot />
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '../../../../http';
import store from '../../../../store';
import notify from '../../../../notifications';

export default {
    data() {
        return {
            provinces: [
                { Id: 0, Name: 'Not specified' },
                { Id: 1, Name: 'A Coruña' },
                { Id: 3, Name: 'Álava' },
                { Id: 4, Name: 'Albacete' },
                { Id: 2, Name: 'Alicante' },
                { Id: 5, Name: 'Almería' },
                { Id: 37, Name: 'Asturias' },
                { Id: 6, Name: 'Avila' },
                { Id: 7, Name: 'Badajoz' },
                { Id: 9, Name: 'Barcelona' },
                { Id: 10, Name: 'Burgos' },
                { Id: 12, Name: 'Cáceres' },
                { Id: 13, Name: 'Cádiz' },
                { Id: 14, Name: 'Cantabria' },
                { Id: 15, Name: 'Castellón' },
                { Id: 11, Name: 'Ciudad Real' },
                { Id: 17, Name: 'Córdoba' },
                { Id: 18, Name: 'Cuenca' },
                { Id: 63, Name: 'El Hierro' },
                { Id: 56, Name: 'Formentera' },
                { Id: 61, Name: 'Fuerteventura' },
                { Id: 19, Name: 'Girona' },
                { Id: 59, Name: 'Gran Canaria' },
                { Id: 20, Name: 'Granada' },
                { Id: 21, Name: 'Guadalajara' },
                { Id: 22, Name: 'Guipúzcoa' },
                { Id: 23, Name: 'Huelva' },
                { Id: 24, Name: 'Huesca' },
                { Id: 55, Name: 'Ibiza' },
                { Id: 25, Name: 'Jaén' },
                { Id: 62, Name: 'La Gomera' },
                { Id: 58, Name: 'La Palma' },
                { Id: 26, Name: 'La Rioja' },
                { Id: 60, Name: 'Lanzarote' },
                { Id: 28, Name: 'León' },
                { Id: 29, Name: 'Lleida' },
                { Id: 30, Name: 'Lugo' },
                { Id: 31, Name: 'Madrid' },
                { Id: 32, Name: 'Málaga' },
                { Id: 54, Name: 'Mallorca' },
                { Id: 53, Name: 'Menorca' },
                { Id: 34, Name: 'Murcia' },
                { Id: 35, Name: 'Navarra' },
                { Id: 36, Name: 'Orense' },
                { Id: 38, Name: 'Palencia' },
                { Id: 39, Name: 'Pontevedra' },
                { Id: 41, Name: 'Salamanca' },
                { Id: 42, Name: 'Segovia' },
                { Id: 43, Name: 'Sevilla' },
                { Id: 44, Name: 'Soria' },
                { Id: 45, Name: 'Tarragona' },
                { Id: 40, Name: 'Tenerife' },
                { Id: 46, Name: 'Teruel' },
                { Id: 47, Name: 'Toledo' },
                { Id: 48, Name: 'Valencia' },
                { Id: 49, Name: 'Valladolid' },
                { Id: 50, Name: 'Vizcaya' },
                { Id: 51, Name: 'Zamora' },
                { Id: 52, Name: 'Zaragoza' }
            ],
            regions: [
                { Id: 6, Name: 'Canary Islands' },
                { Id: 4, Name: 'Balearic Islands' }
            ],
            listTemplatesCreated: [],
            listCampaignsCreated: [],
            formSearch: {
                prefix: null
            },
            formData: {
                Name: null,
                date: moment().format( 'YYYY-MM-DD' ),
                time: '23:59',
                Template: '',
                IncludedLanguages: [],
                IncludedProvinces: [],
                IncludedRegions: []
            },
            formType: 'create',
            template: '',
            cover: null,
            repeat: {
                sale: [
                    {
                        isCoverItem: false,
                        propertyId: null,
                        gallery: null,
                        selectedImg: 0,
                        photo: {
                            id: null,
                            url: null
                        }
                    }
                ],
                rent: [
                    {
                        isCoverItem: false,
                        propertyId: null,
                        gallery: null,
                        selectedImg: 0,
                        photo: {
                            id: null,
                            url: null
                        }
                    }
                ]

            }
        };
    },
    computed: {
        now() {
            return moment().format( 'YYYY-MM-DD' );
        },
        canAdd() {
            return this.$parent.adding;
        },
        canSendTest() {
            return this.cover != null && this.template != null && this.template != '' && ( this.repeat.sale.length > 0 || this.repeat.rent.length > 0 );
        }
    },
    methods: {
        async deleteCampaign( campaignName ) {
            this.$store.dispatch( 'appLoading', true );

            var r = confirm( 'Are you sure?' );

            if ( r ) {
                const response = await http.delete( `/emailschedules/${campaignName}` );

                if ( response.status === 200 ) {
                    notify( {
                        type: 'info',
                        title: 'Campaign deleted OK',
                        text: 'Campaign was deleted correctly'
                    } );
                }

                if ( response.status === 500 ) {
                    notify( {
                        type: 'error',
                        title: 'Something went wrong',
                        text: 'Please try again'
                    } );
                }

                this.getCampaigns();
            }
            this.$store.dispatch( 'appLoading', false );
        },
        async selectAllProvinces( ) {
            this.formData.IncludedRegions = [];
            this.formData.IncludedProvinces = [];
            for ( var province of this.provinces ) {
                this.formData.IncludedProvinces.push( province.Id );
            }
        },
        async resetProvinces( ) {
            this.formData.IncludedProvinces = [];
            this.formData.IncludedRegions = [];
        },
        async getTemplates() {
            this.$store.dispatch( 'appLoading', true );

            const response = await http.get( '/emailtemplates?Take=50' );

            if ( response.status === 500 ) {
                notify( {
                    type: 'error',
                    title: 'Something went wrong',
                    text: 'Please try again'
                } );
                this.$store.dispatch( 'appLoading', false );
                return;
            }

            let out = [];

            const data = await response.json();

            data.forEach( item => {
                out.push( {
                    name: item.Name,
                    type: item.Type
                } );
            } );

            this.listTemplatesCreated = out;

            this.$store.dispatch( 'appLoading', false );
        },
        searchCampaigns( e ) {
            e.preventDefault();
            this.getCampaigns();
        },
        async getCampaigns() {
            this.$store.dispatch( 'appLoading', true );

            await this.getTemplates();

            if ( this.formSearch.prefix == null ) {
                delete this.formSearch.prefix;
            }

            const params = new URLSearchParams( this.formSearch ).toString();

            const response = await http.get( `/emailschedules?${params}` );

            if ( response.status === 500 ) {
                notify( {
                    type: 'error',
                    title: 'Something went wrong',
                    text: 'Please try again'
                } );
                this.$store.dispatch( 'appLoading', false );
                return;
            }

            const data = await response.json();

            store.state.campaignsList = data;
            this.listCampaignsCreated = data;

            this.$store.dispatch( 'appLoading', false );
        },
        async sendForm( e ) {
            e.preventDefault();

            this.$store.dispatch( 'appLoading', true );

            if ( !this.formData.Name ) {
                notify( {
                    type: 'error',
                    text: 'Please enter a name',
                    title: 'Enter name'
                } );
                this.$store.dispatch( 'appLoading', false );
                return;
            }

            if ( !/^[a-zA-Z0-9._-]{5,}$/.test( this.formData.Name ) ) {
                notify( {
                    type: 'error',
                    text: 'Please enter a valid name',
                    title: 'Invalid name'
                } );
                this.$store.dispatch( 'appLoading', false );
                return;
            }

            let formDataCopy = JSON.parse( JSON.stringify( this.formData ) );

            let auxFrmData = formDataCopy;

            auxFrmData[ 'At' ] = moment( formDataCopy.date + ' ' + formDataCopy.time ).format();
            auxFrmData[ 'SubscriberCriteria' ] = {
                IncludedLanguages: formDataCopy.IncludedLanguages,
                IncludedProvinces: formDataCopy.IncludedProvinces,
                IncludedRegions: formDataCopy.IncludedRegions
            };

            delete auxFrmData[ 'time' ];
            delete auxFrmData[ 'date' ];
            delete auxFrmData[ 'IncludedLanguages' ];
            delete auxFrmData[ 'IncludedProvinces' ];
            delete auxFrmData[ 'IncludedRegions' ];

            const response = await http.post( '/emailschedules', auxFrmData );

            if ( response.status === 200 ) {
                notify( {
                    type: 'success',
                    title: 'Campaign created OK',
                    text: 'Campaign was added correctly'
                } );

                this.getCampaigns();

                // reset form
                this.formData.Name = null;
                this.formData.date = null;
                this.formData.time = null;
                this.formData.Template = '';
                this.formData.IncludedLanguages = [];
                this.formData.IncludedProvinces = [];
                this.formData.IncludedRegions = [];
                this.$parent.adding = false;
            } else if ( response.status === 500 ) {
                notify( {
                    type: 'error',
                    title: 'Something went wrong',
                    text: 'Please try again'
                } );
            } else {
                const data = await response.json();
                if ( data.errors ) {
                    notify( {
                        type: 'error',
                        title: 'There was an error',
                        text: data.errors.join( ' ' )
                    } );
                }
            }

            this.$store.dispatch( 'appLoading', false );
        },
        coverItemUrl( item ) {
            return typeof item.selectedImg != 'undefined' ? this.getImgUrl( item.gallery[ item.selectedImg ].url, 'c640x480' ) : null;
        },
        thisCoverActive( item ) {
            return this.cover === this.getImgUrl( item.gallery[ item.selectedImg ].url, 'c640x480' );
        },
        toggleCover( item ) {
            let allSale = this.repeat.sale;
            let allRent = this.repeat.rent;

            allSale.forEach( function( item ) {
                item.isCoverItem = false;
            } );

            allRent.forEach( function( item ) {
                item.isCoverItem = false;
            } );

            let targ = event.target;
            this.cover = targ.value;
            this.thisCoverActive( item );
        },

        onlyNumber( e ) {
            e.target.value = e.target.value.replace( /[^0-9]+/g, '' );
        },

        getImgUrl( src, size ) {
            var srcarr = src.split( '/' );
            var arrsize = srcarr.length;
            var simg = 'c400x300';

            if ( typeof size !== 'undefined' ) {
                simg = size;
            }

            var srcimg = srcarr[ arrsize - 1 ];// x-110433272.jpg

            return 'https://' + srcarr.splice( 2, arrsize - 3 ).join( '/' ) + '/' + simg + '/' + srcimg;
        },

        setPhotoObj( propertyObj ) {
            let targ = event.target;
            let selectedOptionItem = targ.selectedOptions[ 0 ];

            let switch_cont = targ.parentNode.parentNode.parentNode.children[ 2 ];
            let switch_btn = switch_cont.children[ 0 ].children[ 0 ];
            let switch_label = switch_cont.children[ 0 ].children[ 1 ];

            let switch_btn_id = switch_btn.getAttribute( 'id' );

            switch_btn.setAttribute( 'id', 'switch' + switch_btn_id + propertyObj.propertyId );
            switch_label.setAttribute( 'for', 'switch' + switch_btn_id + propertyObj.propertyId );

            propertyObj.photo.id = selectedOptionItem.value;
            propertyObj.photo.url = this.getImgUrl( selectedOptionItem.dataset.url );
        },

        async checkActiveSelect( propertyObj ) {
            let e = event;
            let val = parseInt( e.target.value );

            if ( !Number.isInteger( val ) ) {
                propertyObj.gallery = null;
                return;
            }

            const response = await http.get( `/property/${val}?IsPublic=1` );

            if ( response.status === 200 ) {
                let data = await response.json();

                if ( data.length === 0 ) {
                    alert( 'empty response returned' );
                    e.target.value = null;
                    propertyObj.gallery = null;
                }

                let photos = [];

                for ( let key in data[ 'Photos' ] ) {
                    let imgaux = {
                        id: null,
                        url: null
                    };

                    imgaux.id = parseInt( key ) + 1;
                    imgaux.url = data[ 'Photos' ][ key ].CdnUrl;

                    if ( imgaux.url.length > 0 ) {
                        photos.push( imgaux );
                        propertyObj.gallery = photos.sort( ( a, b ) => ( a.Number > b.Number ) ? 1 : -1 );
                    }
                }

                if ( photos.length == 0 ) {
                    e.target.value = null;
                    propertyObj.gallery = null;
                }
            } else {
                alert( 'There was an error. Please try again' );
                e.target.value = null;
                propertyObj.gallery = null;
            }

            this.$store.dispatch( 'appLoading', false );
        },
        removeRepeatBlock( index, type ) {
            if ( type === 'sale' ) {
                this.repeat.sale.splice( index, 1 );
            } else if ( type === 'rent' ) {
                this.repeat.rent.splice( index, 1 );
            }
        },
        repeatBlock( type ) {
            if ( type === 'sale' ) {
                this.repeat.sale.push( {
                    propertyId: null,
                    isCoverItem: false,
                    gallery: null,
                    selectedImg: 0,
                    photo: {
                        id: null,
                        url: null
                    }
                } );
            } else if ( type === 'rent' ) {
                this.repeat.rent.push( {
                    propertyId: null,
                    isCoverItem: false,
                    gallery: null,
                    selectedImg: 0,
                    photo: {
                        id: null,
                        url: null
                    }
                } );
            }
        },
        onRegionSelect() {
            this.formData.IncludedProvinces = [];
        },
        onProvinceSelect() {
            this.formData.IncludedRegions = [];
        }
    },
    mounted() {
        this.getCampaigns();
        document.title = 'thinkSPAIN - Campaigns';
    }
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/campaigns/form/index.vue